
    import Multiselect from '@vueform/multiselect';
    import BotaoSalvar from '@/components/aplicacao/BotaoSalvar.vue';
    import { Options, Vue } from "vue-class-component";
    import { PerfilConfig } from "@/core/config/PerfisConfig";
    import SiteUtils from '@/assets/ts/aplicacao/site';
    import $ from "jquery";
    import { Prop, Watch } from 'vue-property-decorator';
    import AlocacaoService from "@/service/v1/sigap/AlocacaoService";
    import UnidadeService from "@/service/v1/sigap/UnidadeService";

    @Options({
        name: "TurmaLotacaoEditar",
        components: { Multiselect, BotaoSalvar },
        emits: ['lotacao-alterada'],
    })
    export default class TurmaLotacaoEditar extends Vue {
        @Prop() readonly modal!: any
        @Prop() readonly perfis!: any
        @Prop() readonly modelo!: any
        @Prop() readonly service!: any

        public processando = false;
        public titulo = 'Atualizar Lotacao';

        public id: any = null;
        public matriculaId: any = null;
        public opcaoId: any = null;
        public unidadeId: any = null;
        public opcoes: any = null;
        public unidades: any = null;

        public alocacaoService = new AlocacaoService();
        public unidadeService = new UnidadeService();

        created() {
            this.getOpcao();
            this.getUnidades();
        }

        @Watch('modelo')
        public modeloAlterado() {
            if (!this.modelo || !this.modelo.id) {
                return;
            }

            this.processando = true;
            this.alocacaoService.getModel(this.modelo.id)
                .then(response => {
                    this.id = response.id;
                    this.matriculaId = response.matriculaId ?? response.matricula?.id;
                    this.opcaoId = response.opcao?.id ?? response.opcao;
                    this.unidadeId = response.unidade?.id ?? response.unidadeId;
                    this.processando = false;
                })
                .catch(error => {
                    this.processando = false;
                    this.id = null;
                    this.matriculaId = null;
                    this.opcaoId = null;
                    this.unidadeId = null;
                });
        }

        get hasPermissao(): boolean {
            return SiteUtils.hasPermissao([PerfilConfig.Admin, PerfilConfig.ChefeSTE, PerfilConfig.AuxSTE], this.perfis);
        }

        get opcaoSelect() {
            if (this.opcoes) {
                return this.opcoes.map((item) => { return { value: item.id, label: item.nome.replaceAll('_', ' ') }; });
            }
            return null;
        }

        get unidadeSelect() {
            if (this.unidades) {
                return this.unidades.map((item) => { return { value: item.id, label: item.descricao }; });
            }
            return null;
        }

        public getOpcao() {
            this.alocacaoService.getOpcao()
                .then(response => {
                    this.opcoes = JSON.parse(JSON.stringify(response));
                })
                .catch(() => {
                    this.opcoes = null;
                });
        }

        public getUnidades() {
            this.unidadeService.getTodos('')
                .then(response => {
                    this.unidades = response.data ?? response;
                })
                .catch(() => {
                    this.unidades = null;
                });
        }

        public getdados() {
            const dados: any = {};
            dados.id = this.id;
            dados.MatriculaId = this.matriculaId;
            dados.UnidadeId = this.unidadeId;
            dados.opcao = this.opcaoId;
            return dados;
        }

        public sucesso() {
            this.$emit('lotacao-alterada', null);
            $(`[data-bs-dismiss='modal']`).trigger({ type: 'click' });
        }

        public salvar() {
            if (this.processando || !this.hasPermissao) {
                return;
            }

            if (!this.id || !this.matriculaId || !this.opcaoId || !this.unidadeId) {
                SiteUtils.toastErro('Error!', 'Preencha opcao e unidade.');
                return;
            }

            this.processando = true;
            const dados = this.getdados();
            setTimeout(() => {
                this.service.update(this.id, dados)
                    .then(response => {
                        SiteUtils.toastSucesso('Atualizado com sucesso!', response.message);
                        this.sucesso();
                        this.processando = false;
                    })
                    .catch(error => {
                        this.processando = false;
                        SiteUtils.toastErro('Error!', error.data.message);
                    });
            }, 100);
        }
    }
